import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/app/default_app.svg'
import _imports_1 from '../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-00fbdca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "installedApps" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { class: "headerIcon" }
const _hoisted_4 = { class: "headerIcon" }
const _hoisted_5 = { class: "headerIcon" }
const _hoisted_6 = { class: "headerIcon" }
const _hoisted_7 = {
  key: 1,
  class: "content"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "callItem" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  src: _imports_0,
  class: "app-img"
}
const _hoisted_12 = { class: "callItem" }
const _hoisted_13 = { class: "callItem" }
const _hoisted_14 = { class: "callItem" }
const _hoisted_15 = { class: "noMore" }
const _hoisted_16 = {
  key: 2,
  class: "empty"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "empty-text" }
const _hoisted_19 = {
  key: 2,
  class: "content"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "callItem mobileFirst" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  src: _imports_0,
  class: "app-img"
}
const _hoisted_24 = { class: "callItem mobileVersion" }
const _hoisted_25 = { class: "callItem mobileSize" }
const _hoisted_26 = { class: "callItem" }
const _hoisted_27 = { class: "noMore" }
const _hoisted_28 = {
  key: 2,
  class: "empty"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_30 = { class: "empty-text" }

import { defineComponent, ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getAppList } from "@/api/devices";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import { dateFormat, dateFormatAm } from "@/utils/format";
import { ElMessage } from "element-plus";
import loading from "@/components/chat/loading.vue"
import { gaEvent } from "@/utils/format";
import Tooltip from "@/components/common/tooltip.vue";
import { jsonDataInstall } from '@/mock/installApps.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'installedApps',
  setup(__props) {

const store = useStore();
const { t } = useI18n();
const tableData = ref<any[]>([])
const id = computed(() => {
  return store.state.currentDeviceId;
});
const isVibe = computed(() => !store.state.isVibe);
const isShowMore750 = computed(() => store.state.isShowMore750);
let lastUpdateTime = ref(0)
const showUpdateTime = ref(false)
const globalLoading = ref(false)

onMounted(async () => {
  globalLoading.value = true
  await getAllAppList()
  gaEvent("InstalledApp_PV", {
    event_category: "InstalledApp",
    event_label: tableData.value.length > 0 ? "Data" : "NoData",
  });
})

watch(id, async () => {
  globalLoading.value = true
  tableData.value = []
  await getAllAppList()
  gaEvent("InstalledApp_PV", {
    event_category: "InstalledApp",
    event_label: tableData.value.length > 0 ? "Data" : "NoData",
  });
  if (!isVibe.value) {
    clearInterval(closeFiveM);
    setNewInterval()
  }
})

// 12小时定时更新
let closeFiveM: any
closeFiveM = setInterval(() => {
  globalLoading.value = true
  tableData.value = []
  getAllAppList()
}, 1000 * 60 * 60 * 12);

const getAllAppList = async (isFromSync: Boolean = false) => {
  try {
    if (isVibe.value) {
      tableData.value = jsonDataInstall.data.data
      lastUpdateTime.value = jsonDataInstall.data.update_time
      showUpdateTime.value = true
      return
    }
    const appListSourceRef = computed(() => store.state.appListSource);
    // 取消掉上一次请求
    appListSourceRef.value &&
      appListSourceRef.value.cancel("请勿频繁请求通讯录列表接口");

    const res = await getAppList(id.value);
    console.log('res', res);

    if (res.data.code == 200 && res.data.message == 'OK') {
      if (res.data.data.apps !== null) {
        tableData.value = res.data.data.apps.map((item: any) => {
          return {
            'logo_url': item.logo_url,
            'name': item.name ? item.name : '--',
            'version': item.version ? cutOutString(item.version) : '--',
            'size': item.size ? bytesToMegabytes(item.size) : '--',
            'install_time': item.install_time ? (isVibe.value ? dateFormatAm(item.install_time, "YYYY-MM-DD HH:mm") : dateFormat(item.install_time, "YYYY-MM-DD HH:mm")) : '--',
          }
        })
      }

      if (!isFromSync) {
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      } else {
        gaEvent("InstalledApp_Sync", {
          event_category: "InstalledApp",
          event_label: "Success",
        });
        if (lastUpdateTime.value == res.data.data.update_time) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      }
      console.log("tableData.value:", tableData.value);

      globalLoading.value = false
    }
  } catch (err) {
    if (isFromSync) {
      gaEvent("Contact_Sync", {
        event_category: "Contacts",
        event_label: "Fail",
      });
      ElMessage({
        message: t("chat.syncFailed"),
        type: "error",
      });
    }
    globalLoading.value = false
  } finally {
    setTimeout(() => {
      store.commit("setSyncLoading", false);
    }, 1000)
  }
}

// 截取三位版本号
const cutOutString = (str: String) => {
  const parts = str.split(".");
  const truncatedString = parts.slice(0, 3).join(".");
  return truncatedString
}

// 转化bite为M的单位
const bytesToMegabytes = (bytes: any) => {
  if (isNaN(bytes)) return "0 MB";

  const megabytes = bytes / (1024 * 1024);

  // 保留两位小数并添加 MB 单位
  return megabytes.toFixed(2) + " MB";
}

const updateInfo = async () => {
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  globalLoading.value = true
  tableData.value = []
  await getAllAppList(true)
  clearInterval(closeFiveM);
  setNewInterval()
}

// 设置新的定时器
const setNewInterval = () => {
  closeFiveM = setInterval(() => {
    globalLoading.value = true
    tableData.value = []
    getAllAppList()
  }, 1000 * 60 * 60 * 12);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Installed applications'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateHeaderDate: _ctx.updateHeaderDate,
      onUpdateInfo: updateInfo,
      showRightBox: false
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate", "onUpdateHeaderDate"]),
    _createElementVNode("div", {
      class: _normalizeClass(["label", isShowMore750.value ? '' : 'mobileLabel'])
    }, [
      (isShowMore750.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('famikeep200.Name')), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('famikeep200.Version')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('famikeep200.Size')), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('famikeep200.Installation date')), 1)
          ]))
        : _createCommentVNode("", true),
      (isShowMore750.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (tableData.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["calllogsItem", tableData.value.length > 10 ? 'changePadding' : '']),
                      key: item.contactName
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        (item.logo_url)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.logo_url,
                              class: "app-img"
                            }, null, 8, _hoisted_10))
                          : (_openBlock(), _createElementBlock("img", _hoisted_11)),
                        _createElementVNode("span", null, [
                          _createVNode(Tooltip, {
                            content: item.name
                          }, null, 8, ["content"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(item.version), 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.size), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.install_time), 1)
                    ], 2))
                  }), 128)),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("chat.noMoreText")), 1)
                ]))
              : (globalLoading.value)
                ? (_openBlock(), _createBlock(loading, {
                    key: 1,
                    class: "loading"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                  ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (tableData.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mobilecalllogsItem",
                      key: item.contactName
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        (item.logo_url)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.logo_url,
                              class: "app-img"
                            }, null, 8, _hoisted_22))
                          : (_openBlock(), _createElementBlock("img", _hoisted_23)),
                        _createElementVNode("span", null, [
                          _createVNode(Tooltip, {
                            content: item.name
                          }, null, 8, ["content"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(item.version), 1),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(item.size), 1),
                      _createElementVNode("div", _hoisted_26, _toDisplayString(item.install_time), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("chat.noMoreText")), 1)
                ]))
              : (globalLoading.value)
                ? (_openBlock(), _createBlock(loading, {
                    key: 1,
                    class: "loading"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                  ]))
          ]))
    ], 2)
  ]))
}
}

})